import { Skeleton } from '@/components/ui/skeleton';
import { Card, CardHeader, CardContent } from '@/components/ui/card';

const AssetBlockSkeleton = () => {
  return (
    <Card>
      <CardHeader className="flex-row justify-between items-center gap-2 space-y-0">
        <Skeleton className="h-6 w-32" />
        <Skeleton className="h-8 w-28" />
      </CardHeader>
      <CardContent className="space-y-6">
        <Skeleton className="h-4 w-8/12" />
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="bg-background-secondary border border-border rounded-lg p-5 space-y-1">
            <Skeleton className="h-7 w-16" />
            <Skeleton className="h-3 w-40" />
          </div>
          <div className="bg-background-secondary border border-border rounded-lg p-5 space-y-1">
            <Skeleton className="h-7 w-32" />
            <Skeleton className="h-3 w-28" />
          </div>
        </div>
        <div className="space-y-4">
          <Skeleton className="h-10 w-full" />
          <Skeleton className="h-32 w-full rounded-md" />
        </div>
      </CardContent>
    </Card>
  );
};

export default AssetBlockSkeleton;
